import React, { useEffect, useState } from 'react';
import { Loader2, Rss, ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const feedUrl = `${API_URL}/api/rss.xml`;

const RSSFeed = () => {
  const [status, setStatus] = useState('checking'); // checking | ready | error

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(feedUrl);
        if (!res.ok) throw new Error('bad status');
        setStatus('ready');
      } catch {
        setStatus('error');
      }
    };
    check();
  }, []);

  return (
    <div className="min-h-screen pt-32 pb-24 px-6" data-testid="rss-page">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-50 rounded-full mb-6">
          <Rss className="text-orange-500" size={28} />
        </div>
        <h1 className="text-5xl font-light mb-4">RSS Feed</h1>
        <p className="text-lg text-gray-600 mb-10 leading-relaxed">
          Subscribe to get every new article automatically delivered to your favorite
          RSS reader (Feedly, Reeder, Inoreader, NetNewsWire, etc.).
        </p>

        <div className="bg-gray-50 rounded-lg p-6 mb-8 text-left">
          <p className="text-sm text-gray-500 mb-2">Feed URL</p>
          <div className="flex items-center gap-3">
            <code className="flex-1 bg-white border border-gray-200 px-4 py-3 rounded-md text-sm break-all" data-testid="rss-feed-url">
              {feedUrl}
            </code>
            <button
              onClick={() => {
                navigator.clipboard.writeText(feedUrl);
              }}
              className="px-4 py-3 bg-black text-white rounded-md hover:bg-gray-800 text-sm"
              data-testid="rss-copy-btn"
            >
              Copy
            </button>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={feedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors"
            data-testid="rss-open-btn"
          >
            <Rss size={18} /> Open Feed
            <ExternalLink size={14} />
          </a>
        </div>

        <div className="mt-8 text-sm">
          {status === 'checking' && (
            <p className="flex items-center justify-center gap-2 text-gray-500">
              <Loader2 size={14} className="animate-spin" /> Checking feed status…
            </p>
          )}
          {status === 'ready' && <p className="text-emerald-600">Feed is live and reachable.</p>}
          {status === 'error' && <p className="text-red-600">Feed is unreachable right now.</p>}
        </div>
      </div>
    </div>
  );
};

export default RSSFeed;
